/**
 * Normalize organizer copy: treat <br> as line breaks, store/edit as plain text.
 */
export function normalizeEmailCopyInput(text) {
    return String(text ?? '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\r\n/g, '\n')
        .trim();
}
export function escapeHtml(text) {
    return String(text ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
/** Plain text for text emails and admin preview. */
export function formatEmailBodyPlain(text) {
    return normalizeEmailCopyInput(text);
}
/**
 * Safe HTML for email-designer HTML bodies (use with Mustache {{{emailBodyTextHtml}}}).
 */
export function formatEmailBodyHtml(text) {
    const plain = normalizeEmailCopyInput(text);
    if (!plain)
        return '';
    const escaped = escapeHtml(plain);
    return escaped.replace(/\n\n+/g, '<br /><br />').replace(/\n/g, '<br />');
}
export function buildEmailBrandingCopy(headline, bodyText) {
    const emailHeadline = formatEmailBodyPlain(headline);
    const emailBodyText = formatEmailBodyPlain(bodyText);
    return {
        emailHeadline,
        emailBodyText,
        emailHeadlineHtml: formatEmailBodyHtml(emailHeadline),
        emailBodyTextHtml: formatEmailBodyHtml(emailBodyText),
    };
}
